import ajax from 'Site/js/util/ajax.fetch';
import collapseDirective from 'Site/directive/collapse';
import dropdownDirective from 'Site/directive/dropdown';
import Editable from 'Site/component/Editable.vue';
import EventCard from 'Parties/component/EventCard.vue';
import Media from 'Media/component/Media.vue';
import GoogleMap from 'Location/component/GoogleMap.vue';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import store from 'Site/js/store';
import Wall from 'Wall/component/Wall.vue';
import wallMediaMixin from 'Wall/js/mixins/media.page';
import WallPost from 'Wall/component/Post.vue';
import 'Wall/scss/wall-sidebar.scss';
import Vue from 'vue';
import { mapState } from 'vuex';
import clubCreate from '../../component/clubCreate';
import clubHeader from '../../component/clubHeader';
import clubMediaMixin from '../mixin/clubMedia';
import ClubCard from '../../component/ClubCard.vue';
import subscribeMixin from '../mixin/subscribe';

export default {
    clubs() {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'clubsPage',
            store,
            mixins: [PromptSignup],
            components: {
                ClubCard
            },
            data() {
                return {
                    clubs: this.$store.state.config.data.clubs,
                    filters: {
                        keywords: '',
                        sort: this.$store.state.siteConfig.user.id ? 'distance' : 'likeCount'
                    }
                };
            },
            computed: {
                ...mapState({
                    isMobile: state => state.isMobile,
                    t: state => state.t
                }),
                filteredClubs() {
                    const filter = this.filters.sort;
                    let sort = 'ASC';
                    let { clubs } = this;
                    if (this.filters.keywords) {
                        clubs = clubs.filter(club => club.name.toLowerCase().indexOf(this.filters.keywords.toLowerCase()) !== -1);
                    }
                    if (filter === 'name' || filter === 'distance') {
                        sort = 'DESC';
                    }
                    return clubs.sort((a, b) => {
                        if (filter === 'name') {
                            if (a[filter].toLowerCase() > b[filter].toLowerCase()) {
                                return 1;
                            }
                            if (a[filter].toLowerCase() < b[filter].toLowerCase()) {
                                return -1;
                            }
                            return 0;
                        }
                        if (a[filter] === null || typeof a[filter] === 'undefined') {
                            return sort === 'ASC' ? -1 : 1;
                        }
                        if (b[filter] === null || typeof b[filter] === 'undefined') {
                            return sort === 'ASC' ? 1 : -1;
                        }
                        if (a[filter] > b[filter]) {
                            return sort === 'ASC' ? -1 : 1;
                        }
                        if (a[filter] < b[filter]) {
                            return sort === 'ASC' ? 1 : -1;
                        }
                        return 0;
                    });
                }
            }
        });
    },
    'clubs-view': () => {
        clubHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#club-body',
            name: 'clubBody',
            store,
            components: {
                Editable,
                GoogleMap,
                Media,
                Wall
            },
            computed: mapState({
                clubAjaxParams: state => ({ url: 'club', id: state.config.data.id }),
                t: state => state.t
            }),
            data() {
                return {
                    ownerIsClub: this.$store.state.config.data.ownerIsClub,
                    allMedia: this.$store.state.config.data.media,
                    showLogo: true
                };
            },
            directives: {
                collapse: collapseDirective,
                dropdown: dropdownDirective
            },
            methods: {
                convertProfile(club, id) {
                    ajax.update('profile', {
                        id,
                        club
                    }).then(() => {
                        if (club) {
                            this.$store.dispatch('notify', { msg: this.t.convert_profile.convert });
                            this.ownerIsClub = true;
                        } else {
                            this.$store.dispatch('notify', { msg: this.t.convert_profile.revert });
                            this.ownerIsClub = false;
                        }
                    });
                },
                removeLogo(text, buttonText) {
                    const callback = () => {
                        ajax.update('club', {
                            id: this.id,
                            banner: null
                        }).then((response) => {
                            this.$store.dispatch('showNotify', { msg: response.message });
                            this.showLogo = false;
                        });
                    };
                    this.$store.dispatch('showConfirm', {
                        text,
                        callback: callback.bind(this),
                        buttonText
                    });
                }
            },
            mixins: [clubMediaMixin, subscribeMixin]
        });
    },
    'clubs-reviews': () => {
        clubHeader();
    },
    'clubs-media': () => {
        clubHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#club-body',
            name: 'clubMediaPage',
            store,
            components: {
                Media
            },
            computed: {
                highlightedCount() {
                    return this.allMedia.filter(filterMedia => filterMedia.highlighted).length;
                }
            },
            data: {
                type: 'club'
            },
            directives: {
                dropdown: dropdownDirective
            },
            mixins: [clubMediaMixin, wallMediaMixin]
        });
    },
    'clubs-events': () => {
        clubHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#club-body',
            name: 'clubEventsPage',
            store,
            components: {
                EventCard
            }
        });
    },
    'clubs-view-view-post': () => {
        clubHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#club-body',
            name: 'clubViewPostPage',
            store,
            components: {
                WallPost
            },
            computed: mapState(['t'])
        });
    },
    'clubs-submit': () => {
        if (document.querySelector('#club-create-vue')) {
            clubCreate();
        }
    }
};
